import Navigationbar from "../components/Navigationbar";
import AdminDropdown from "../components/AdminDropDown";
import MonthPicker from "../components/MonthlyReportComponents/MonthPicker";
import ReflectionSection from "../components/MonthlyReportComponents/ReflectionSection";
import DownloadPDFButton from "../components/DownloadPDFButton";
import FeedbackSection from "../components/MonthlyReportComponents/FeedbackSection"
import FinanceTable from "../components/MonthlyReportComponents/FinanceTable";
import { useState,useCallback} from "react";
import { subMonths } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import LineChartComponent from "../components/MonthlyReportComponents/LineChartComponent";
import OverviewCards from "../components/MonthlyReportComponents/OverviewCards";
import usePDFGenerator from "../hooks/usePDFGenrator";
import advices from '../JSON/advices.json'
import '../Styles/Månedsrapport.css'
import '../Styles/button.css'
import useBalanceData from "../hooks/useBalanceData";
import useBudgetData from "../hooks/useBudgetData";
import useLiquidityData from "../hooks/useLiquidityData";
import useLastYearBalanceData from "../hooks/useLastYearBalanceData";
import { useNavigate } from "react-router-dom";
import { formatDateToISO, getInitialDateStates } from '../utilities/dateUtils';
import useAdviceGenerator from "../hooks/useAdviceGenerator";
import useProcessedData from "../hooks/useProcessedData";
import { useSelectedCompany } from "../contexts/SelectedCompanyContext";
import useFetchCompanies from "../hooks/CompanyHooks/useFetchCompanies";
import { useAdmin } from "../contexts/AdminContext";
import LoadingComponent from "../components/LoadingComponent";
import { useAuth } from "../contexts/AuthContext";


function Månedsrapport () {
  const navigate = useNavigate();
  const auth = useAuth()
  const currentDate = new Date();
  const { selectedCompany, setSelectedCompany, isCompanyLoading } = useSelectedCompany();
  const { companies, isLoading: isCompaniesLoading, error } = useFetchCompanies();
  const defaultDates = getInitialDateStates(currentDate);
  const [startDate, setStartDate] = useState(defaultDates.startDate);
  const [endDate, setEndDate] = useState(defaultDates.endDate);
  const [lastYearStartDate, setLastYearStartDate] = useState(defaultDates.lastYearStartDate);
  const [lastYearEndDate, setLastYearEndDate] = useState(defaultDates.lastYearEndDate);
  

  const { generatePDF } = usePDFGenerator();
  const {isAdmin, setIsAdmin} = useAdmin();
  const { processedBalanceData, isLoading: isBalanceLoading, error: balanceError } = useBalanceData(selectedCompany, startDate, endDate);
  const { processedBudgetData, isLoading: isBudgetLoading, error: budgetError } = useBudgetData(selectedCompany, startDate, endDate);
  const { processedLiquidityData, isLoading: isLiquidityLoading, error: liquidityError } = useLiquidityData(selectedCompany, startDate, endDate, "likvid");
  const { processedLastYearBalanceData, isLoading: isLastYearBalanceLoading, error: lastYearBalanceError } = useLastYearBalanceData(selectedCompany, lastYearStartDate, lastYearEndDate);
 
  const {
    omsætningIaltEntireLastYearAmount,
    omsætningIaltAmount,
    omsætningBudgetAmount,
    produktionsomkostningerAmount,
    produktionsomkostningerBudgetAmount,
    administrationsomkostningerBudgetAmount,
    administrationsomkostningerAmount,
    periodensResultatBudgetAmount,
    periodensResultatAmount,
  } = useProcessedData(processedBalanceData, processedBudgetData, processedLastYearBalanceData);

  const adviceList = useAdviceGenerator(
    processedBalanceData, 
    processedBudgetData, 
    omsætningIaltAmount, 
    omsætningBudgetAmount, 
    produktionsomkostningerAmount, 
    administrationsomkostningerAmount, 
    periodensResultatAmount, 
    produktionsomkostningerBudgetAmount, 
    administrationsomkostningerBudgetAmount, 
    periodensResultatBudgetAmount, 
    advices
    );
    const handleDateChange = (newStartDate, newEndDate) => {
      const newStartYear = new Date(newStartDate).getFullYear();
  
      setStartDate(newStartDate);
      setEndDate(newEndDate);
  
      const lastYearStartDate = formatDateToISO(new Date(newStartYear - 1, 0, 1));
      const lastYearEndDate = formatDateToISO(new Date(newStartYear - 1, 11, 31));
      
      setLastYearStartDate(lastYearStartDate);
      setLastYearEndDate(lastYearEndDate);
  };
  
const handleDownloadPDF = useCallback(() => {
  generatePDF('contentToConvert', 'MyFile.pdf');
}, [generatePDF]); 

const onContactClick = () => {
  navigate("/easy-admin.dk/kontakt/")
}

  // if (isCompanyLoading || isCompanyLoading || isBudgetLoading || isBalanceLoading || isLiquidityLoading || isLastYearBalanceLoading || !selectedCompany) {
  //   return <LoadingComponent />;
  // }
    return (
      <div>
        <Navigationbar></Navigationbar>
        <div className="container Månedsrapport-container">
          <h1 className="main-header">Månedsrapport</h1>
          {isAdmin && (
            <AdminDropdown
              selectedCompany={selectedCompany}
              setSelectedCompany={setSelectedCompany}
              allCompanies={companies}
              isCompanyLoading={isCompanyLoading}
            />
          )}
          {auth.currentUser ? (
            <div>
              <DownloadPDFButton onDownload={handleDownloadPDF} />
              <div id='contentToConvert'>
                <div className="col">
                  <OverviewCards
                    omsætningIalt={omsætningIaltAmount}
                    resultatIalt={periodensResultatAmount}
                  />
                </div>
                <div className="month-picker-container">
                  <p className="month-text" style={{color:"#FD6925"}}>Vælg Måned</p>
                  <MonthPicker
                    selectedDate={new Date(startDate)}
                    onDateChange={handleDateChange}
                    currentDate={subMonths(currentDate, 1)}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                  />
                </div>
                <div className="row">
                  <FeedbackSection
                    adviceList={adviceList}
                    resultatIalt={periodensResultatAmount}
                  />
                  <div>
                    {processedBalanceData.map(({ accountNumber, accountName, amount, percentage}) => {
                      return (
                        <FinanceTable
                          key={accountNumber}
                          balance={{ accountNumber, accountName, amount, percentage }}
                          omsætningIaltEntireLastYearAmount={omsætningIaltEntireLastYearAmount}
                          processedLastYearBalanceData={processedLastYearBalanceData}
                          isLastYearBalanceDataLoading={isLastYearBalanceLoading}
                          isLastYearBalanceDataError={lastYearBalanceError}
                          isBalanceLoading={isBalanceLoading}
                          balanceError={balanceError}
                        />
                      );
                    })}
                  </div>
                  <div className="col-2 border border-dark border-end-0 fixed-width-column mt-5" style={{backgroundColor:'#001633'}}><p style={{color:'white'}}>Likviditet</p></div>
                  <div className="col-2 border border-dark border-end-0 fixed-width-column mt-5" style={{backgroundColor:'#001633'}}><p style={{color:'white'}}>Konto Beløb</p></div>
                  <div className="col-1 border border-dark border-end-0 fixed-width-column mt-5" style={{backgroundColor:'#001633'}}></div>
                  <div className="col-1 border border-dark border-end-0 fixed-width-column mt-5" style={{backgroundColor:'#001633'}}></div>
                  <div>
                    {processedLiquidityData.map(({ accountNumber, accountName, amount, percentage }) => (
                      <FinanceTable
                        key={accountNumber}
                        balance={{ accountNumber, accountName, amount }}
                        percentage={percentage}
                      />
                    ))}
                  </div>
                  <div className="col-2 border border-dark border-end-0 fixed-width-column mt-5" style={{backgroundColor:'#001633'}}><p style={{color:'white'}}>Budget Konto</p></div>
                  <div className="col-2 border border-dark border-end-0 fixed-width-column mt-5" style={{backgroundColor:'#001633'}}><p style={{color:'white'}}>Konto Beløb</p></div>
                  <div className="col-1 border border-dark border-end-0 fixed-width-column mt-5" style={{backgroundColor:'#001633'}}><p style={{color:'white'}}>%</p></div>
                  <div className="col-1 border border-dark border-end-0 fixed-width-column mt-5" style={{backgroundColor:'#001633'}}><p style={{color:'white'}}></p></div>
                  <div>
                    {processedBudgetData.map(({ accountNumber, accountName, periods, percentage }) => {

                      return (
                        <FinanceTable
                          key={accountNumber}
                          balance={{ accountNumber, accountName, periods, percentage }}
                        />
                        );
                      })}
                    </div>
                  </div>
                <div className="mt-5">
                  <LineChartComponent selectedCompany={selectedCompany} startDate={startDate}/>
              </div>
                <ReflectionSection />
              <div className="mt-5">
                <h2 className="sub-header">Har du brug for en forklaring af din månedsrapport? Tag fat i os.</h2>
                <div className="d-flex justify-content-center mb-5">
                <button className="generic-ea-btn" onClick={onContactClick}>Kontakt os!</button>
                </div>
              </div>
            </div>
        </div>
              ) : (<div style={{fontWeight:'bold'}} className="d-flex justify-content-center">Login for at se din månedsrapport  <Link className="ms-2"  to="/sign-in">  Klik her</Link></div>)}
        </div>
        <Footer/>
    </div>
)
}
export default Månedsrapport;